document.addEventListener("DOMContentLoaded", () => {
  const hasAccessories = document.querySelector("ul.accessories-list");
  if (hasAccessories) {
    document.querySelectorAll(".product-form__submit").forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        // 主产品已选数量
        let data = [];
        const productQuantity = document.querySelector(
          ".price-per-item__container .quantity__input"
        ).value;
        // 获取当前已选变体的id
        const variantId = document.querySelector(
          ".product-form .product-variant-id"
        )?.value;
        variantId &&
          data.push({
            form_type: "product",
            utf8: "✓",
            id: parseInt(variantId, 10),
            quantity: parseInt(productQuantity, 10),
          });

        // 获取配件商品信息
        hasAccessories.querySelectorAll("input").forEach((item) => {
          if (item.checked) {
            data.push({
              form_type: "product",
              utf8: "✓",
              id: parseInt(item.value, 10),
              quantity: 1,
            });
          }
        });

        const controLoading = () => {
          document.querySelectorAll(".product-form__submit").forEach((item) => {
            item.classList.toggle("loading");
          });

          document
            .querySelectorAll(".product-form__submit .loading__spinner")
            .forEach((item) => {
              item.classList.toggle("hidden");
            });
        };
        const fetchCart = () => {
          fetch(`${routes.cart_url}?section_id=cart-drawer`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              const targetElement = document.querySelector("cart-drawer");
              const sourceElement = html.querySelector("cart-drawer");
              targetElement.innerHTML = sourceElement.innerHTML;
              targetElement.classList.add("active");
              targetElement.classList.remove("is-empty");
              document.querySelector("body").classList.add("overflow-hidden");
            })
            .catch((e) => {
              console.error(e);
            });
        };
        // 显示loading
        controLoading();
        // 提交请求

        fetch("/cart/add.json", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: data }),
        })
          .then(() => {
            controLoading();
            // 更新侧边栏购物车
            fetchCart();
          })
          .catch((resaon) => {
            alert("add cart error: ", resaon);
          });
      });
    });
  }

  // 给quick-jump-bar中的add to cart添加事件
  const addToCartBtn = document.querySelector(
    ".quick-jump-bar-wrapper .add-to-cart-btn"
  );
  const morePaymentBtn = document.querySelector("#more-payment-options-link");
  if (addToCartBtn && morePaymentBtn) {
    addToCartBtn.addEventListener("click", () => {
      addToCartBtn.querySelector(".loading__spinner").classList.remove("hidden");
      morePaymentBtn.click();
    });
  }
});
